export default __webpack_public_path__ + "static/media/vLuna.0d331f25.svg";